<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>{{"admin.countries.create" | translate}} {{"admin.countries.country" | translate}}</h2>
  <mat-card-content>
    <form (submit)="sendCreationRequest()" [formGroup]="countryCreateForm" autocomplete="off">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.country" | translate}} {{"admin.countries.code" | translate}}</mat-label>
          <input [formControl]="codeControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.country" | translate}}</mat-label>
          <input [formControl]="nameControl" matInput type="text">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{"admin.countries.region" | translate}}</mat-label>
          <mat-select [formControl]="regionControl">
            <mat-option value=""> - </mat-option>
            <mat-option *ngFor="let region of regions" [value]="region.value">{{region.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="edit-dialog-buttons-container">
          <button mat-raised-button (click)="closeDialog()" type="button" >
            <span>Close</span>
          </button>
          <button [disabled]="countryCreateForm.invalid" mat-raised-button color="primary" type="submit">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-dialog-content>
